module.exports = __webpack_public_path__ + "img/3a25c57.png";